export default {
    data(){
        return {
            requestCount: 0
        };
    },
    computed: {
        loading(){
            return this.requestCount > 0;
        }
    },
    methods: {
        addRequestCount(){
            this.requestCount++;
        },
        subRequestCount(){
            this.requestCount--;
        }
    }
}